export default Object.freeze({
  // No votes have been cast on this reference.
  PENDING_ACTION: 'PENDING_ACTION',

  // The reference has votes and the current user has not voted.
  PENDING_ACTION_BY_YOU: 'PENDING_ACTION_BY_YOU',

  // The reference has votes and the current user has voted.
  PENDING_ACTION_ALREADY_TAKEN: 'PENDING_ACTION_ALREADY_TAKEN',

  // The reference requires a vote but the current user is not eligible to vote.
  PENDING_ACTION_BY_OTHERS: 'PENDING_ACTION_BY_OTHERS',

  // The reference has conflicting votes and the current user can resolve conflicts.
  PENDING_CONFLICT_RESOLUTION_BY_YOU:
    'PENDING_CONFLICT_RESOLUTION_BY_YOU',

  // The reference has conflicting votes and the current user cannot resolve conflicts.
  PENDING_CONFLICT_RESOLUTION_BY_OTHERS:
    'PENDING_CONFLICT_RESOLUTION_BY_OTHERS',

  // The reference has been included by consensus (matching votes).
  INCLUDED_BY_CONSENSUS: 'INCLUDED_BY_CONSENSUS',

  // The reference has been excluded by consensus (matching votes).
  EXCLUDED_BY_CONSENSUS: 'EXCLUDED_BY_CONSENSUS',

  // The reference has been included by conflict resolution.
  INCLUDED_BY_CONFLICT_RESOLUTION: 'INCLUDED_BY_CONFLICT_RESOLUTION',

  // The reference has been excluded by conflict resolution.
  EXCLUDED_BY_CONFLICT_RESOLUTION: 'EXCLUDED_BY_CONFLICT_RESOLUTION',

  // The reference has been included by manual override of a previous outcome.
  INCLUDED_BY_OVERRIDE: 'INCLUDED_BY_OVERRIDE',

  // The reference has been excluded by manual override of a previous outcome.
  EXCLUDED_BY_OVERRIDE: 'EXCLUDED_BY_OVERRIDE',

  // The reference was included on upload (pre-screened).
  INCLUDED_ON_UPLOAD: 'INCLUDED_ON_UPLOAD',

  // The reference was excluded on upload (pre-screened).
  EXCLUDED_ON_UPLOAD: 'EXCLUDED_ON_UPLOAD',

  // The reference was excluded by system suggestion (stopping criteria met).
  EXCLUDED_BY_SUGGESTION: 'EXCLUDED_BY_SUGGESTION',

  // The reference has been extracted after two matching extraction reports.
  EXTRACTED_BY_CONSENSUS: 'EXTRACTED_BY_CONSENSUS',

  // The reference has been extracted after consensus review on existing extraction reports.
  EXTRACTED_BY_CONFLICT_RESOLUTION:
    'EXTRACTED_BY_CONFLICT_RESOLUTION',
});
